import { getOr } from 'lodash/fp';

export const getOrEmptyString = getOr('');
